module.exports = __webpack_public_path__ + "media/images/beach-cd55203f22d6186732453e684d12007f.png";